export const appsCatalogFilteredSetsListDatatable = "/apps/catalog_filtered_sets_list_datatable";
